module.exports = __webpack_public_path__ + "media/application/images/ui/badge-peoples-choice-with-text-xs-8a7f0dfc2a4e2baae9b52414cbf7df40.png";